const ConfirmationList = () => import('./index')
const ShowConfirmation = () => import('./show_confirmation')

export default [
  {
    path: '/confirmation',
    name: 'confirmation.index',
    component: ConfirmationList,
    meta: { requiresAuth: true }
  },
  {
    path: '/confirmation/show',
    name: 'confirmation.show',
    component: ShowConfirmation,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/confirmation/routes.js